import axios from 'axios';
import moment from 'moment';

const SERVER_ADDRESS = "calendar_crane.php";

export default class ServerApi {
    static createEvent(date, code, callback) {
        const params = {
            d: date.format("YYYY-MM-DD"),
            c: code,
            t: 'a'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            const data = response.data || {};
            if (data.success) {
                callback(true);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            // eslint-disable-next-line
            console.log(e);
            callback(false, "Unexpected error");
        });
    }
    static deleteEvent(event, code, callback) {
        const params = {
            d: event.date.format("YYYY-MM-DD"),
            c: code,
            t: 'd'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            const data = response.data || {};
            if (data.success) {
                callback(true);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            // eslint-disable-next-line
            console.log(e);
            callback(false, "Unexpected error");
        });
    }
    static queryContact(event, code, callback) {
        const params = {
            d: event.date.format("YYYY-MM-DD"),
            c: code,
            t: 'i'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            const data = response.data || {};
            if (data.success) {
                callback(true, data);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            // eslint-disable-next-line
            console.log(e);
            callback(false, "Unexpected error");
        });
    }
    static getEvents(start, end, callback) {
        const params = {
            s: start.format("YYYY-MM-DD"),
            e: end.format("YYYY-MM-DD"),
            t: 'e'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            callback(response.data.reduce((res, event) => {
                const date = moment(event.date);
                res[date.format('YYYYMMDD')] = {...event, date: date};
                return res;
            }, {}));
        }).catch(e => {
            // eslint-disable-next-line
            console.log(e);
            callback({});
        });
    }
}
